import { makeStyles } from "@material-ui/styles"
import { CELL_WIDTHS } from "@utils";

const useStyle = makeStyles((theme) => ({
  
  descriptionEditorContainer: {
    // borderWidth: 0,
    // borderRightWidth: 1,
    // borderStyle: "solid",
    width: "100%",
    // marginLeft: CELL_WIDTHS.DRAG_HANDLE,
  },
  addDragHandlePadding: {
    paddingLeft: CELL_WIDTHS.DRAG_HANDLE,
  },
  descriptionEditor: {
    padding: "16px 8px",
    "&.d0, &.d1": {
      paddingLeft: CELL_WIDTHS.EXPAND.DEPTH_1 - 6,
    },
    "&.d2": {
      paddingLeft: CELL_WIDTHS.EXPAND.DEPTH_2 - 6,
    },
    "&.d3": {
      paddingLeft: CELL_WIDTHS.EXPAND.DEPTH_3 - 6,
    },
    "&.d4": {
      paddingLeft: CELL_WIDTHS.EXPAND.DEPTH_4 - 6,
    },
  },
  isSticky: {
    // maxWidth: `calc(100% - ${CELL_WIDTHS.DRAG_HANDLE + 1}px)`,
    borderStyle: "solid",
    borderWidth: 0,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    position: "sticky",
    left: CELL_WIDTHS.DRAG_HANDLE,
  },
  visibilityButtonWithoutNumeration: {
    position: "absolute",
    top: 24,
    "&.d0, &.d1": {
      left: CELL_WIDTHS.EXPAND.DEPTH_1 - 26,
    },
    "&.d2": {
      left: CELL_WIDTHS.EXPAND.DEPTH_2 - 26,
    },
    "&.d3": {
      left: CELL_WIDTHS.EXPAND.DEPTH_3 - 26,
    },
  },
  visibilityButtonWithNumeration: {
    position: "absolute",
    top: 24,
    right: 0,
  },
  descriptionEditorStatic: {
    // borderTopWidth: 1,
    // borderTopColor: `${theme.props.border} !important`,
    backgroundColor: `${theme.props.backgroundSecondary} !important`,
  },
  border: {
    borderBottomWidth: 1,
    borderBottomColor: `${theme.props.border} !important`,
  },
  contentSemiOpaque: {
    "& .ql-editor": {
      opacity: 0.3,
    }
  },
  filler: {
    display: "block",
    width: 1,
    minHeight: "100%",
    borderWidth: 0,
    borderRightWidth: 1,
    borderStyle: "solid",
    borderColor: "inherit",
  },
  dashedSpacing: {
    borderBottomWidth: "1px !important",
    borderBottomStyle: "dashed",
    borderBottomColor: `${theme.props.border} !important`,
  }
}));

export default useStyle;
